<nz-spin
  *ngIf="loadingService.loading$ | async"
  [nzSize]="'large'"
  id="site-loading-bar"
  nzSimple
></nz-spin>
